import { FormattedMessage } from 'react-intl'
import { Grid } from '@mui/material'
import InputField from 'components/form/InputField'
import FormSectionContainer from 'components/layout/FormSectionContainer'
import { UseFormReturn } from 'react-hook-form'
import RichTextEditor from '../RichTextEditor'

interface Props {
  form: UseFormReturn<any>
}

export default function ChallengeReadOnlyPhase3({ form }: Props): JSX.Element {
  const { register, control } = form

  return (
    <>
      <FormSectionContainer>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <h2>
              <FormattedMessage id="challenges.descriptions" />
            </h2>
          </Grid>
          <Grid item xs={6}>
            <InputField
              register={register}
              name="info.subtitle.content"
              type="text"
              label={<FormattedMessage id="challenges.subtitle" />}
              outlined
              maxCharactersSoftLimit={80}
              maxLength={80}
              required
              placeholder="Required"
              disabled
            />
          </Grid>
          <Grid item xs={6}></Grid>
          <Grid item xs={6}>
            <RichTextEditor
              name="info.longDescription.content"
              control={control}
              label={<FormattedMessage id="challenges.challengeDescription" />}
              placeholder={'Required'}
              maxCharactersSoftLimit={3500}
              minHeight="420px"
              maxHeight="420px"
              required
              disabled
            />
          </Grid>
        </Grid>
      </FormSectionContainer>

      <FormSectionContainer>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <h2>
              <FormattedMessage id="strings.prizes" />
            </h2>
          </Grid>
          <Grid item xs={6}>
            <InputField
              register={register}
              name="prizeInfo.shortDescription.content"
              type="text"
              label={<FormattedMessage id="challenges.prizeText" />}
              outlined
              maxCharactersSoftLimit={200}
              disabled
            />
          </Grid>
        </Grid>
      </FormSectionContainer>
    </>
  )
}
